(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bloom-hero"] && !Shopify.designMode) return;
  try {
    
function initBloomBanners(scope = document) {
  scope.querySelectorAll('[data-bb-banner]').forEach((hero) => {
    if (hero.dataset.bbReady) return;
    hero.dataset.bbReady = 'true';
    const photo = hero.querySelector('.bb-hero__photo');
    if (!photo) return;
    const choices = hero.previousElementSibling;
    const original = {};
    ['src', 'srcset', 'sizes', 'alt', 'width', 'height'].forEach((name) => { original[name] = photo.getAttribute(name); });
    const available = ['rubans', 'dore', 'produits'];
    const apply = () => {
      const match = hero.dataset.bbCompare === 'true' ? window.location.hash.match(/^#bloom-banner-(rubans|dore)$/) : null;
      const design = match ? match[1] : hero.dataset.bbDefault;
      const proposed = available.includes(design);
      hero.dataset.bbDesign = design;
      hero.classList.toggle('bb-hero--proposed', proposed);
      if (proposed) {
        photo.removeAttribute('srcset');
        photo.removeAttribute('sizes');
        photo.src = hero.dataset[`${design}Src`];
        photo.alt = hero.dataset[`${design}Alt`];
        photo.width = 1672;
        photo.height = 941;
      } else {
        Object.entries(original).forEach(([name, value]) => {
          if (value === null) photo.removeAttribute(name);
          else photo.setAttribute(name, value);
        });
      }
      if (choices && choices.matches('[data-bb-banner-choices]')) {
        choices.hidden = !match && hero.dataset.bbCompare !== 'true';
        choices.querySelectorAll('[data-bb-banner-choice]').forEach((link) => {
          if (link.dataset.bbBannerChoice === design) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
      }
    };
    apply();
    window.addEventListener('hashchange', apply);
  });
}
initBloomBanners();
document.addEventListener('shopify:section:load', (event) => initBloomBanners(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloom-reviews"] && !Shopify.designMode) return;
  try {
    
function initBloomReviews(root) {
  root.querySelectorAll('.bb-reviews').forEach(section => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const track = section.querySelector('.bb-reviews__track:not(.bb-reviews__track--sample)');
    const buttons = section.querySelectorAll('[data-review-direction]');
    if (!track || !buttons.length) return;

    const sync = () => buttons.forEach(button => {
      button.disabled = Number(button.dataset.reviewDirection) < 0
        ? track.scrollLeft <= 2
        : track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    });

    buttons.forEach(button => button.addEventListener('click', () => {
      const card = track.querySelector('.bb-reviews__card');
      const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
      track.scrollBy({
        left:Number(button.dataset.reviewDirection) * step,
        behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }));

    track.addEventListener('scroll', sync, {passive:true});
    if ('ResizeObserver' in window) new ResizeObserver(sync).observe(track);
    sync();
  });
}

initBloomReviews(document);
document.addEventListener('shopify:section:load', event => initBloomReviews(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloom-universe"] && !Shopify.designMode) return;
  try {
    
function initBloomUniverse(scope=document){scope.querySelectorAll('[data-bb-universe]').forEach((section)=>{if(section.dataset.ready)return;section.dataset.ready='true';const initial=section.dataset.shape;const apply=()=>{const match=section.querySelector('.bb-universe__choices')?location.hash.match(/^#bloom-universe-(arche|ovale)$/):null;const shape=match?match[1]:initial;section.dataset.shape=shape;section.querySelectorAll('[data-bb-shape]').forEach((link)=>{if(link.dataset.bbShape===shape)link.setAttribute('aria-current','true');else link.removeAttribute('aria-current');});};apply();window.addEventListener('hashchange',apply);});}
initBloomUniverse();document.addEventListener('shopify:section:load',(event)=>initBloomUniverse(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
